"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiVideoSlotReelSpinner = void 0;
var _gsap = _interopRequireDefault(require("gsap"));
var _core = require("@dragon/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Spin States
 * 
 * Spin Up.
 * Occurs when the reel winds up a small bit, this is to simulate mechanical reels. It goes up before it accelerates.
 * 
 * Spin Start
 * When the reel starts moving down and accelerate towards full speed.
 * 
 * full Speed
 * the reel is spinning waiting for stop command. usually where it is while waiting for server to respond.
 * 
 * spin Stop
 * reel decelerates and comes to a stop. It will over shoot slightly.
 * 
 * spin down
 * "bounce back"
 * when spin stop ends having over shot the actually stop place, the spin down slowly brings it back to the actual end position
 * again something done to simulate mechanical reel behavior.
 * 
 * anticipate.
 * When there is a "slot stop" anticipate effect in the game this plays. if this happens spins stop and spin down is NOT called. This replaces does tow state.
 * there is now "bounce back" with anticipate.
 */
/**
 * Handles the spinning of the reels and the symbols.
 * Its best to only override the event calls which stats with "on", all others can be override but contains logic 
 * required for the internal workings of this spinner so override only if you need and know what you are doing.
 */
var PixiVideoSlotReelSpinner = exports.PixiVideoSlotReelSpinner = /*#__PURE__*/function () {
  /**
   * 
   * 
   * @param reels 
   * @param pixiApp 
   * @param settings 
   * @param symbolHeight 
   * @param reelVSeparator 
   * @param numSymbols 
   * @param scatterGroups 
   * @param symbolInfo 
   * @param skipEvents 
   * @param fakeReels 
   */
  function PixiVideoSlotReelSpinner(reels, pixiApp, settings, symbolHeight, reelVSeparator, numSymbols, scatterGroups, symbolInfo, skipEvents, clientReels) {
    _classCallCheck(this, PixiVideoSlotReelSpinner);
    _defineProperty(this, "_isReSpin", void 0);
    _defineProperty(this, "_spinning", void 0);
    _defineProperty(this, "_reelTimelines", void 0);
    _defineProperty(this, "_reels", void 0);
    _defineProperty(this, "_reelCellHeight", void 0);
    _defineProperty(this, "_reelResults", void 0);
    /**
     * total nr of scatters, note this can be from different symbols.
     */
    _defineProperty(this, "_totalNumOfScatters", 0);
    _defineProperty(this, "_numOfScattersPerGroup", void 0);
    _defineProperty(this, "_numOfWilds", 0);
    _defineProperty(this, "_symbolCount", void 0);
    _defineProperty(this, "_quickStopping", false);
    _defineProperty(this, "_anticipating", void 0);
    /**
     * the resolve for all reels having stopped.
     */
    _defineProperty(this, "_fullStopCallback", void 0);
    _defineProperty(this, "_isFreeSpin", void 0);
    _defineProperty(this, "_settings", {
      ReelSpinDelay: 0,
      ReelStopDelay: 0,
      SpinUpDuration: 0.1,
      SpinUpDistance: -0.1,
      SpinStartDuration: 0.3,
      SpinStartDistance: 4,
      FullSpeedDuration: 0.2,
      FullSpeedDistance: 4,
      SpinStopDuration: 0.21,
      SpinStopDistance: 4.30,
      SpinDownDuration: 0.18,
      SpinDownDistance: 4,
      AnticipationDuration: 2.2,
      AnticipationDistance: 20
    });
    _defineProperty(this, "_scatterGroups", void 0);
    _defineProperty(this, "_symbolInfo", void 0);
    _defineProperty(this, "_numSymbols", void 0);
    _defineProperty(this, "_tickerFunctionBind", void 0);
    _defineProperty(this, "_pixiApp", void 0);
    _defineProperty(this, "_sendEvents", void 0);
    _defineProperty(this, "_anticipateOnReelSpinStop", true);
    /**
     * If spinner uses client side reels to create pattern effects etc.
     */
    _defineProperty(this, "_useClientReels", void 0);
    /**
     * the actual configured client reels.
     */
    _defineProperty(this, "_clientReels", void 0);
    /**
     * each reels own counter.
     */
    _defineProperty(this, "_clientReelsCounters", void 0);
    _defineProperty(this, "_anticipatinScatterGroupIndex", void 0);
    this._settings = _objectSpread(_objectSpread({}, this._settings), settings);
    this._reels = reels;
    // Trigger calc.
    this._reelCellHeight = symbolHeight + reelVSeparator;
    this._scatterGroups = scatterGroups;
    this._symbolInfo = symbolInfo;
    this._numSymbols = numSymbols;
    this._sendEvents = !skipEvents;
    this.buildTweens();
    this._tickerFunctionBind = this._tick.bind(this);
    this._pixiApp = pixiApp;

    // prepare symbol counting
    this._symbolCount = [];
    for (var index = 0; index < numSymbols; index++) {
      this._symbolCount.push(0);
    }
    // prepare scatter group counting
    this._numOfScattersPerGroup = [];
    for (var _index = 0; _index < scatterGroups.length; _index++) {
      this._numOfScattersPerGroup.push(0);
    }
    this.reset();
    if (clientReels) {
      this._useClientReels = true;
      this._clientReels = Object.assign({}, clientReels);
      this._clientReelsCounters = [];
      for (var i = 0; i < reels.length; i++) {
        this._clientReelsCounters.push(0);
      }
    }
    this._pixiApp.ticker.add(this._tickerFunctionBind);
  }

  //#region Controls
  return _createClass(PixiVideoSlotReelSpinner, [{
    key: "reSpinReel",
    value: function reSpinReel(reelIndex) {
      var _this = this;
      //    CORE.dispatch(playSound(SoundPack.Game, false, GameSounds.ReelStop))
      //    CORE.dispatch(playSound(SoundPack.Game, false, GameSounds.ReelSpin))

      // L.debug('REEL SPINNER |  reSpinReel on reel ' + reelIndex)
      var reel = this._reels[reelIndex];
      return new Promise(function (resolve, reject) {
        reel.onReSpin(_this._isFreeSpin);
        _this._isReSpin = true;
        _this._quickStopping = false;
        _this._spinning = true;
        var timeline = _this._reelTimelines[reelIndex];
        timeline.restart();
        resolve();
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this._quickStopping = false;
      this._isReSpin = false;
      this._numOfWilds = 0;
      this._totalNumOfScatters = 0;
      for (var index = 0; index < this._symbolCount.length; index++) {
        this._symbolCount[index] = 0;
      }
      for (var _index2 = 0; _index2 < this._numOfScattersPerGroup.length; _index2++) {
        this._numOfScattersPerGroup[_index2] = 0;
      }
    }
    /**
     * 
     * WARNING! handle rejected promises from this, there are several cases where a spin start can be rejected.
     * 
     * @param freespin 
     * @returns 
     */
  }, {
    key: "spin",
    value: function spin(freespin) {
      var _this2 = this;
      this._isFreeSpin = freespin;

      // make sure we reset
      this.reset();
      return new Promise(function (resolve, reject) {
        if (!_this2._spinning) {
          // First cell in reel starts moving, set reel state.
          // moved here for possible race con. Could cause double SPIN command on controller.
          if (_this2._sendEvents) _core.CORE.dispatch({
            type: _core.REELS_STATE_SPINNING
          });
          _this2._spinning = true;
          var _loop = function _loop(index) {
            setTimeout(function () {
              var timeline = _this2._reelTimelines[index];
              timeline.timeScale(1);
              timeline.restart();
              if (index == _this2._reelTimelines.length - 1) {
                resolve();
              }
            }, index * _this2._settings.ReelSpinDelay);
          };
          for (var index = 0; index < _this2._reelTimelines.length; index++) {
            _loop(index);
          }
        } else {
          reject();
        }
      });
    }
  }, {
    key: "quickStop",
    value: function quickStop() {
      // L.debug('REEL SPINNER |  QUICK STOP')
      // stopping has not started.
      this._quickStopping = true;

      // Kill pending timeouts
      for (var index = 0; index < this._reels.length; index++) {
        var timeline = this._reelTimelines[index];
        if (timeline.isActive()) {
          var currentLabel = timeline.currentLabel();
          if (currentLabel == 'anticipate' || currentLabel == 'spinDown' || currentLabel == 'spinStop') {
            timeline.timeScale(8);
          } else {
            timeline.seek('spinStop', false);
          }
        }
      }
    }

    /**
     * set the reels to a fixed value, used on game start with starting reels. also set last reels
     */
  }, {
    key: "setReels",
    value: function setReels(reels) {
      var _this3 = this;
      return new Promise(function (resolve, reject) {
        _this3._reelResults = reels;
        for (var r = 0; r < reels.length; r++) {
          _this3._reels[r].setSymbolsOnReel(reels[r]);
        }
        resolve();
      });
    }

    /**
     * Cancel spin, if something went wrong with debit etc. this should return to prev values.
     */
  }, {
    key: "cancel",
    value: function cancel() {
      console.log('cancel');
      if (this._reelResults) this.stop(this._reelResults);
      this.quickStop();
    }
  }, {
    key: "stop",
    value: function stop(reelResult) {
      var _this4 = this;
      // L.debug('REEL SPINNER |  stop,  is Respin:' + this._isReSpin + ', is FreeSpin:' + this._isFreeSpin)
      this._reelResults = reelResult;
      return new Promise(function (resolve, reject) {
        _this4._fullStopCallback = resolve;

        //quick stop already triggered
        if (_core.CORE.getState().game.quickStop || _core.CORE.getState().config.fastPlay) {
          _this4.quickStop(); // this fires for ALL reels. not just this active one.
          return;
        }
        for (var reel = 0; reel < _this4._reelTimelines.length; reel++) {
          var timeline = _this4._reelTimelines[reel];
          // find the first active timeline/spinning reel.
          if (timeline.isActive()) {
            // L.debug('REEL SPINNER |  stop on reel ' + reel)

            if (_this4._isReSpin && _this4._anticipateOnReelSpinStop) {
              // L.debug('REEL SPINNER |  reSpin Anticipate Stop on reel ' + reel)
              timeline.seek('anticipate', true);
            } else {
              // L.debug('REEL SPINNER |  reSpin regular stop on reel ' + reel)
              timeline.seek('spinStop', false);
            }
            break;
          }
        }
      });
    }
    /** for sequential stopping/normal stop */
  }, {
    key: "_stopNextReel",
    value: function _stopNextReel(reelIndex) {
      // L.debug('REEL SPINNER |  stopNextReel ' + reelIndex + ' is quick stopping: ' + this._quickStopping)

      if (this._quickStopping) {
        for (var reel = reelIndex; reel < this._reelTimelines.length; reel++) {
          //  // L.debug('REEL SPINNER |  Active: ' + reel + '    ' + this._reelTimelines[reel].isActive())
          if (this._reelTimelines[reel].isActive()) return;
        }
        this.allReelsStopped();
      }
      for (var _reel = reelIndex; _reel < this._reelTimelines.length; _reel++) {
        // L.debug('REEL SPINNER |  Active: ' + reel + '    ' + this._reelTimelines[reel].isActive())

        if (this._reelTimelines[_reel].isActive()) {
          // L.debug('REEL SPINNER |  next active to stop is ' + reelIndex)

          // Check if we should anticipate next reel due to scatter landing.
          for (var index = 0; index < this._numOfScattersPerGroup.length; index++) {
            if (this._numOfScattersPerGroup[index] >= this._scatterGroups[index].anticipateCount && !(this._scatterGroups[index].freeSpinDisable && this._isFreeSpin) && (!this._scatterGroups[index].reelPresence || this._scatterGroups[index].reelPresence.indexOf(reelIndex + 1) > -1)) {
              this._reelTimelines[_reel].play('anticipate', true);
              this.anticipate(_reel, index);
              return;
            }
          }
          // check if we should anticipate next stop due to respi
          if (this._isReSpin && this._anticipateOnReelSpinStop) {
            this._reelTimelines[_reel].play('anticipate', true);
            return;
          }
          // Do a regular stop.
          else {
            // L.debug('REEL SPINNER |  regular Stop on ' + reelIndex)
            this._reelTimelines[_reel].seek('spinStop', false);
            return;
          }
        }
      }
      // this is only reached if there are not ACTIVE reels spinning. call all reels have stopped.
      this.allReelsStopped();
    }

    //#endregion
    /**
     * This can help when you get weird spin behavior due to first run not being a normal run.
     * Re instantiate the tweens, safe to run multiple times but DO NOT run during a spin or before a spin has ended.
     */
  }, {
    key: "buildTweens",
    value: function buildTweens() {
      var _this$_reelTimelines,
        _this5 = this;
      (_this$_reelTimelines = this._reelTimelines) === null || _this$_reelTimelines === void 0 || _this$_reelTimelines.forEach(function (element) {
        element.kill();
      });
      this._reelTimelines = [];
      var _loop2 = function _loop2(r) {
          var reel = _this5._reels[r];
          timeline = _gsap["default"].timeline({
            paused: true
          });
          reel.spinPosition = 0;
          timeline.to(reel, {
            duration: _this5._settings.SpinUpDuration,
            // paused: true,
            spinPosition: _this5._settings.SpinUpDistance,
            // the cell count,
            /// Needed it will easy by default.
            ease: 'power1.in',
            onStart: function onStart() {
              reel.stopped = false;
              reel.spinPosition = 0;
              reel.onSpinUp(_this5._isFreeSpin, _this5._isReSpin);
              // First cell in reel starts moving, set reel state.
              if (r == 0) {
                _this5.firstReelSpin();
                _this5.onFirstReelSpin();
                //CORE.dispatch({ type: REELS_SPINING_UP });
              }
            }
          }, 'spinUp').to(reel, {
            duration: _this5._settings.SpinStartDuration,
            // paused: true,
            spinPosition: _this5._settings.SpinStartDistance,
            // the cell count,
            /// Needed it will easy by default.
            ease: 'power1.in',
            onStart: function onStart() {
              reel.onSpinStart(_this5._isFreeSpin, _this5._isReSpin);
            },
            onComplete: function onComplete() {
              reel.spinPosition = 0;
            }
          }, 'spinStart').to(reel, {
            duration: _this5._settings.FullSpeedDuration,
            // time for a full lap,
            spinPosition: _this5._settings.FullSpeedDistance,
            // the cell count,
            /// Needed it will easy by default.
            ease: 'none',
            repeat: 1000,
            onStart: function onStart() {
              reel.onSpinFullSpeed(_this5._isFreeSpin);
            },
            onComplete: function onComplete() {
              reel.spinPosition = 0;
            }
          }, 'fullSpeed').to(reel, {
            duration: _this5._settings.SpinStopDuration,
            spinPosition: _this5._settings.SpinStopDistance,
            // the cell count, the over shoot
            ease: 'none',
            onStart: function onStart() {
              reel.spinPosition = 0;
              reel.stopping = true;
              reel.onSpinStop(_this5._quickStopping, _this5._isFreeSpin, _this5._isReSpin);

              // L.debug('REEL SPINNER | onStart spinStop on reel ' + r)
            },
            onComplete: function onComplete() {
              // L.debug('REEL SPINNER | onComplete spinStop on reel ' + r)
              _this5._ensureCorrectSymbols(reel);
              // CORE.dispatch(playSound(SoundPack.Game, false, GameSounds.ReelStop, 1, false, this._reelStereoSettings[r]))
              _this5._countSymbols(reel);
            }
          }, 'spinStop').to(reel, {
            duration: _this5._settings.SpinDownDuration,
            spinPosition: _this5._settings.SpinDownDistance,
            // Needed it will easy by default.
            ease: 'power1.out',
            onStart: function onStart() {
              reel.onSpinDown(_this5._quickStopping, _this5._isFreeSpin, _this5._isReSpin);
            },
            onComplete: function onComplete() {
              reel.spinPosition = 0;
              // so it wont do anticipate
              _this5._reelTimelines[r].pause();
              reel.stopping = false;
              reel.stopped = true;
              reel.onFullStop(_this5._quickStopping, _this5._isFreeSpin, _this5._isReSpin);
              _this5.onReelStopped(_this5._quickStopping, _this5._isFreeSpin, _this5._isReSpin, reel);
              _this5._stopNextReel(r);
            }
          }, 'spinDown').to(reel, {
            duration: _this5._settings.AnticipationDuration,
            spinPosition: _this5._settings.AnticipationDistance,
            // the cell count,
            ease: 'power2.out',
            onStart: function onStart() {
              reel.spinPosition = 0;
              reel.stopping = true;
            },
            onComplete: function onComplete() {
              reel.spinPosition = 0;
              reel.onStopAnticipate(r);
              _this5._countSymbols(reel);
              reel.stopping = false;
              reel.stopped = true;
              _this5.onReelStopped(_this5._quickStopping, _this5._isFreeSpin, _this5._isReSpin, reel, true);
              // this might cause issues. but since spin down dont happen on anticipate we need it. might break older games
              reel.onSpinDown(_this5._quickStopping, _this5._isFreeSpin, _this5._isReSpin, true);
              _this5._stopNextReel(r);

              // IMPORTANT!!!!!
              // This fixes the anticipation bug when getting anticipate on first spin.
              // the bug occurs with the init values of tweens. the spinStop will tween from 4 to target rather than correct 0 to target. 
              // cant do this in gsap3
              //   this._reelTimelines[r].invalidate(); // 
            }
          }, 'anticipate');
          _this5._reelTimelines.push(timeline);
        },
        timeline;
      for (var r = 0; r < this._reels.length; r++) {
        _loop2(r);
      }
    }
  }, {
    key: "firstReelSpin",
    value: function firstReelSpin() {}
  }, {
    key: "onFirstReelSpin",
    value: function onFirstReelSpin() {}
  }, {
    key: "onScatterLand",
    value: function onScatterLand(symbolId, reelIndex, scatterGroupIndex, symbolCount) {}
    /** 
     * called every tween tick. 
     * controls what symbols are being shown on the Reels.
    */
  }, {
    key: "_tick",
    value: function _tick() {
      for (var r = 0; r < this._reels.length; r++) {
        var reel = this._reels[r];
        for (var c = 0; c < reel.symbols.length; c++) {
          var symbol = reel.symbols[c];
          var prevY = symbol.y;

          // Move cell to top once it reaches bottom and is out of sight.
          symbol.y = (reel.spinPosition + c) % reel.symbols.length * this._reelCellHeight - this._reelCellHeight;
          if (symbol.y < -(this._reelCellHeight / 2) && prevY > 0) {
            this.setSymbol(reel, symbol, c, r);
          }
        }
      }
    }

    /**
     * Used to set the symbol by the spinner, applies if it should be blurred etc. Override for custom. Will use "fake"
     * reels from game constants if they are present.
     * 
     * @param reel 
     * @param symbol 
     * @param symbolIndexOnReel 
     * @param reelIndex 
     */
  }, {
    key: "setSymbol",
    value: function setSymbol(reel, symbol, symbolIndexOnReel, reelIndex) {
      // Reel spinning, random symbols or static client side reel representations.
      if (!reel.stopping) {
        if (!this._useClientReels) {
          symbol.updateSymbol(Math.floor(Math.random() * this._numSymbols), true);
          return;
        } else {
          symbol.updateSymbol(this._clientReels[reelIndex][this._clientReelsCounters[reelIndex]], true);
          this._clientReelsCounters[reelIndex]++;
          this._clientReelsCounters[reelIndex] = this._clientReelsCounters[reelIndex] % this._clientReels[reelIndex].length;
        }
      } else if (symbolIndexOnReel == 0) {
        // random upper adjacent.
        // upper adjacent, should not be blurred
        symbol.updateSymbol(Math.floor(Math.random() * this._numSymbols));
      }
      // final symbol on stop.
      else {
        symbol.updateSymbol(this._reelResults[reelIndex][symbolIndexOnReel - 1]);
      }
    }

    /**
     * This is called on spinDown, meaning when its still not on full stop.
     * When anticipating its called on stop, since there is no spin down.
     *  Don't call symbol events here, only count on scatters, wilds etc.*  
     */
  }, {
    key: "_countSymbols",
    value: function _countSymbols(reel) {
      // count the symbols that landed on this reel.
      // note we skip adjacent hence we start on 1.
      for (var c = 1; c < reel.symbols.length; c++) {
        var sinfo = this._symbolInfo[reel.symbols[c].symbolID];
        if (sinfo.scatter) this._totalNumOfScatters++;
        if (sinfo.wild) this._numOfWilds++;
        this._symbolCount[reel.symbols[c].symbolID]++;

        // for every scatter group defined
        for (var index = 0; index < this._scatterGroups.length; index++) {
          // check if the symbol on the cell is part of this scatter group;
          if (this._scatterGroups[index].symbols.indexOf(reel.symbols[c].symbolID) > -1) {
            this._numOfScattersPerGroup[index]++;
            this.onScatterLand(reel.symbols[c].symbolID, reel.reelIndex, index, this._symbolCount);
          }
        }
      }
    }
    /**
     * All reels has reached full stop,
     * this contain logic for the spinner, can be overriden but make sure you do a super call
     * Use onAllReelsStopped for most cases.
     */
  }, {
    key: "allReelsStopped",
    value: function allReelsStopped() {
      // L.debug('REELSPINNER |  allReelsStopped')

      this.onAllReelsStopped();
      if (this._sendEvents) _core.CORE.dispatch({
        type: _core.REELS_STATE_STOPPED
      });

      // stop can occur without a stop function being called setting this.
      if (this._fullStopCallback) this._fullStopCallback();
      this._spinning = false;
      this._isReSpin = false;
      if (this._anticipating) this.stopAnticipate();
      this._totalNumOfScatters = 0;
      // bugged
      //  this._pixiApp.ticker.remove(this._tickerFunctionBind);
    }
    /**
     * All reels stopped event callback. this should be overridden if needed.
     */
  }, {
    key: "onAllReelsStopped",
    value: function onAllReelsStopped() {}
    /** 
     * this contain logic for the spinner, can be override but make sure you do a super call
     * Use onAnticipate for most cases when needing to do sounds animations etc.
     */
  }, {
    key: "anticipate",
    value: function anticipate(reelIndex, scatterGroupIndex) {
      this.onAnticipate(reelIndex, scatterGroupIndex);
      if (!this._anticipating) {
        this._anticipating = true;
        this._anticipatinScatterGroupIndex = scatterGroupIndex;
        this.onAnticipateStart(scatterGroupIndex);
      }
      for (var index = 0; index < this._reels.length; index++) {
        this._reels[index].onAnticipate(reelIndex, scatterGroupIndex, this._isFreeSpin);
      }
    }
    /**
     * Anticipate start event callback. this should be overridden if needed. called once for every reel that anticipates
     */
  }, {
    key: "onAnticipate",
    value: function onAnticipate(reelIndex, scatterGroupIndex) {}
    /** Anticipate start, called once at start. not for every reel*/
  }, {
    key: "onAnticipateStart",
    value: function onAnticipateStart(scatterGroupIndex) {}
    /** Anticipate start, called once at start. not for every reel*/
  }, {
    key: "onAnticipateStop",
    value: function onAnticipateStop(scatterGroupIndex) {}

    /** 
     * this contain logic for the spinner, can be overriden but make sure you do a super call
     * Use onStopAnticipate for most cases when needing to do sounds animations etc.
     * 
     * NOTE overrideing this might break the "weird reel spins if anticipate on first spin bug"
     */
  }, {
    key: "stopAnticipate",
    value: function stopAnticipate() {
      this.onStopAnticipate(this._anticipatinScatterGroupIndex);
      this._anticipating = false;
      this._anticipatinScatterGroupIndex = undefined;

      // This is very important. Anticipate tends to fuck things up. this solves the invalidate that was used before however that was not fool proof.
      this.buildTweens();
      if (this._totalNumOfScatters == 2) {
        for (var r = 0; r < this._reels.length; r++) {
          var reel = this._reels[r];
          for (var c = 0; c < reel.symbols.length; c++) {
            reel.symbols[c].lighten();
          }
        }
      }
    }
    /**
     * Anticipate stop event callback. this should be overridden if needed for custom animations and sounds etc.
     */
  }, {
    key: "onStopAnticipate",
    value: function onStopAnticipate(scatterGroupIndex) {}

    /**
     * When a reel stopps. event on reel spinner.
     */
  }, {
    key: "onReelStopped",
    value: function onReelStopped(quickStop, isFreeSpin, isReSpin, reel, anticipated) {}

    /**
     * Ensures that on stop it has the correct symbols this can be wrong if quickstop is triggered.
     * @param reel 
     */
  }, {
    key: "_ensureCorrectSymbols",
    value: function _ensureCorrectSymbols(reel) {
      for (var index = 1; index < reel.symbols.length; index++) {
        this.setSymbol(reel, reel.symbols[index], index, reel.reelIndex);
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      this._pixiApp.ticker.remove(this._tickerFunctionBind);
      for (var index = 0; index < this._reelTimelines.length; index++) {
        this._reelTimelines[index].kill();
      }
    }
  }]);
}();
//# sourceMappingURL=PixiVideoSlotReelSpinner.js.map